import React, {Component} from "react";

const locale = (typeof (window.AppWizardLocale) !== 'undefined' ? window.AppWizardLocale : false);
if (!locale) {
    throw new Error('Error: Locale not loaded');
}

class CocktailsList extends Component {
    constructor(props) {
        super(props);
        this.createEntries = this.createEntries.bind(this);
    }

    createEntries(item) {
        let ingredients = this.props.ingredients[item.id];

        let featuredImage = '';
        if (item.type === 'post') {
            featuredImage = <img src={item.image_url} alt="" className="cocktail__image"/>;
        } else if (item.type === 'video') {
            featuredImage = <iframe width="560" height="315" src={item.image_url}
                                    title={item.title} frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen></iframe>

        }
        return (
            <div key={item.id}
                 className="cocktail-container d-flex flex-column justify-content-center align-items-center">
                <article className="cocktail d-flex flex-wrap">
                    <div
                        className={"cocktail__info text-center px-0 " + (item.type === 'post' ? 'cocktail__info--img' : null)}>
                        <div className="d-flex flex-column justify-content-end align-items-center"
                            // style={{backgroundImage: `url('${item.image_url}')`}}
                        >

                            {
                                item.type === 'post' ? <h3 className="cocktail__name text-center"
                                                           dangerouslySetInnerHTML={{__html: item.title}}/> : null
                            }
                            <div className="w-100">{featuredImage}</div>
                            <div className="cocktail__btn--desktop w-100 px-3 my-5">
                                <a onClick={e => {
                                    e.preventDefault();
                                    this.props.onItemClick(item.id);
                                }} href="#" className="button button--orange w-100 button--create-shopping-list">
                                    {locale.texts.create_shopping_list}
                                </a>
                            </div>
                        </div>

                    </div>
                    <div className="cocktail__recipe-container">
                        <div className="cocktail__recipe pr-3">
                            <div className="ingredients__container">
                                {
                                    item.type === 'video' ? <h3 className="cocktail__recipe__title"
                                                                dangerouslySetInnerHTML={{__html: item.title}}/> : null
                                }
                                <h3 className="cocktail__recipe__heading">{locale.texts.ingredients_title}</h3>
                                <ul className="cocktail__ingredients">
                                    {ingredients && ingredients.map(entry =>
                                        <li key={entry.product} className="ingredient">
                                            <span className="ingredient__quantity">{entry.quantity} {entry.um}</span>
                                            <span className="ingredient__name">{entry.product}</span>
                                        </li>
                                    )}
                                </ul>
                            </div>
                            <div className="recipe__container">
                                <h3 className="cocktail__recipe__heading">{locale.texts.recipe}</h3>
                                <p className="cocktail__recipe__text" dangerouslySetInnerHTML={{__html: item.content}}/>
                            </div>
                            <a onClick={e => {
                                e.preventDefault();
                                this.props.onItemClick(item.id);
                            }} href="#" className="button button--xl button--create-shopping-list">
                                {locale.texts.create_shopping_list}
                            </a>
                        </div>
                        <div className="cocktail__btn--mobile">
                            <a onClick={e => {
                                e.preventDefault();
                                this.props.onItemClick(item.id);
                            }} href="#" className="button button--orange w-100 button--create-shopping-list">
                                {locale.texts.create_shopping_list}
                            </a>
                        </div>
                    </div>
                </article>
            </div>
        );
    }

    render() {
        return (
            <div className="cocktails-container">
                {this.props.items.map(this.createEntries)}
            </div>
        );
    }
}

export default CocktailsList;
